import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import { ConfirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from 'primereact/button';

const ExpensesApprove = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [username] = useState(cookies.USERNAME);
	const [showConfirmModal, setShowConfirmModal] = useState(false);

	const acceptLabel = (
		<div style={{ color: 'white' }}>
			<FontAwesomeIcon icon={faCheck} />&nbsp; Yes
		</div>
	);

	const rejectLabel = (
		<div>
			<FontAwesomeIcon icon={faXmark} />&nbsp; No
		</div>
	);

	useEffect(() => {
		if (props.editData) {
			setShowConfirmModal(true);
		}
	}, [props.editData]);
		
	const handleCancel = () => {
		setShowConfirmModal(false);
		props.onHide();
	};

	function ApproveExpenses(_data) {
		let functionName = "";

		try {
			functionName = "ApproveExpenses";
			props.onLoading(true, "Approving this expenses, please wait...");

			setShowConfirmModal(false);

			const data = {
				EXPENSES_MST_ID: _data.EXPENSES_MST_ID,
				USER_MST_GUID: _data.USER_MST_GUID,
				USERNAME: _data.USERNAME,
				TOTAL_CLAIM: _data.TOTAL_CLAIM,
				UPDATE_NAME: username,
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};

			http
				.post("api/expensesHistory/ApproveExpenses", data, { timeout: 5000 })
				.then(() => {
					toast.success("Expenses is successfully approved.");
					props.onReload();
				})
				.catch((err) => {
					toast.error("Failed to approve expenses.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to approve expenses.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};

	return (
		<>
			<ConfirmDialog
				visible={showConfirmModal}
				onHide={handleCancel}
				content={({ headerRef, contentRef, footerRef, hide }) => (
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							padding: '2rem',
							backgroundColor: '#fff',
							borderRadius: '12px',
							boxShadow: '0 0 10px rgba(0,0,0,0.15)',
							textAlign: 'center',
						}}
					>
						<div
							style={{
								backgroundColor: '#0d6efd',
								color: 'white',
								width: '106px',
								height: '106px',
								borderRadius: '50%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								marginTop: '-78px',
								fontSize: '3rem',
							}}
						>
							<i className="pi pi-question" style={{ fontSize: '2.5rem' }} />
						</div>
							
						<div ref={headerRef} style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '1rem' }}>
							Confirmation
						</div>
						<p ref={contentRef} style={{ marginTop: '1rem', fontSize: '1rem' }}>
							Are you sure you want to approve this expenses?
						</p>
						<div ref={footerRef} style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
							<Button
								label={rejectLabel}
								outlined
								style={{ width: '6rem' }}
								onClick={(e) => {
									hide(e);
									handleCancel();
								}}
							/>
							<Button
								label={acceptLabel}
								style={{ border: 'none', width: '6rem' }}
								onClick={(e) => {
									hide(e);
									ApproveExpenses(props.editData);
								}}
							/>
						</div>
					</div>
				)}
				className="custom-confirm-dialog"
			/>
		</>
	);
};

export default ExpensesApprove;